import { ErrorMessage, useFormikContext } from 'formik'
import { FC } from 'react'
import './formikErrorMessage.scss'

type Props = {
  name: string
}
const FormikErrorMessage: FC<Props> = ({ name }: Props) => {
  const formikContext = useFormikContext()

  if (!formikContext) {
    return null
  }

  const renderFormError = (errorMessage: string) => (
    <span className="form-error-message">{errorMessage}</span>
  )

  return <ErrorMessage name={name} render={renderFormError} />
}
export default FormikErrorMessage
